import { Form } from 'antd';
import { Input } from '@admin-panel/ui';
import { SectionHeading, labelNode } from '../helpers';

type LookNameSectionProps = {
  showHeading: boolean;
};

const LookNameSection = ({ showHeading }: LookNameSectionProps) => (
  <section className="space-y-3">
    {showHeading ? <SectionHeading title="Look Name" /> : null}
    <Form.Item
      label={labelNode('Look Name')}
      name="look_name"
      style={{ marginBottom: 0 }}
    >
      <Input placeholder="Look name" />
    </Form.Item>
  </section>
);

export default LookNameSection;
